export const INITIAL_TENANT_LICENSE_VALUES = {
  licensePackage: '',
  startDate: new Date().toISOString().split('T')[0],
  endDate: '',
  revokeOldLicense: false,
}
